// extracted by mini-css-extract-plugin
export default {"dangerZone":"lJukw"};